import { Component, OnInit, ViewChild } from '@angular/core';
import { RowSelectEventArgs, RowDeselectEventArgs, GridComponent, AggregateService, SelectionSettingsModel, ToolbarItems, PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Location } from '@angular/common';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MenuFuncionService, ComunidadService, ConsorcioService, TipoGastoService, ServicioGastoService, ExpensaService, GastoService, MonedaService, TipoMovimientoService, TenantService } from '../../../../src/app/shared/services';
import { MenuFuncionCodes, SearchComunidadRequest, Comunidad, ConceptosRecargo, MetodoRedondeoExpensa, SearchTipoGastoRequest, TipoGasto, UnidadFuncionalTipoGastoPorcentajeItemDto, GridPageSettings, ConceptosRecargoConstants } from '../../../../src/app/shared/model';
import { ExpensaUnidadFuncionalGastosPorcentajeRequestDto, ServicioGasto, SearchServicioGastoRequest,SearchPendientesLiquidacionRequest, SearchTipoMovimientoRequest, TipoMovimiento, TenantFeatureFlags } from '../../../../src/app/shared/model';
import { LocalStorageKeys, Consorcio, SaveExpensaLiquidacionRequestDto, ComunidadTiposGastos, ExpensaTipoGastoComunidadServicioGasto } from '../../../../src/app/shared/model';
import { Moneda, SearchMonedaRequest, SaveExpensaLiquidacionResponseDto } from '../../../../src/app/shared/model';

import { DialogExpensaLiquidacionSimulacionComponent } from '../expensa/components/dialogExpensaLiquidacionSimulacion.component';

@Component({
    selector: 'app-expensaLiquidacion',
    templateUrl: './expensaLiquidacion.component.html',
    styles: ['./expensaLiquidacion.component.css'],
    providers: [ AggregateService ]
})

export class ExpensaLiquidacionComponent implements OnInit {

    @ViewChild('gastosComunidadGrid')
    public gastosComunidadGrid: GridComponent;
    @ViewChild('gastosUfsGrid')
    public gastosUfsGrid: GridComponent;

    public gastosSelectionOptions: SelectionSettingsModel;
    public selectionOptions: SelectionSettingsModel;
    public pageSizes: number[];
    public toolbarOptions: ToolbarItems[];
    public pageSettings: PageSettingsModel;

    form0Group: FormGroup;
    form1Group: FormGroup;
    form2Group: FormGroup;
    form3Group: FormGroup;

    canView: boolean = false;
    canConfigExpensas: boolean = false;
    isValidating: boolean = false;
    isSaving: boolean = false;
    hasSearched: boolean = false;
    mostrarSeleccionConceptosRecargo: boolean = false;
    hayUfsSinCubrirTotal: boolean = true;

    isComunidadSearching: boolean = false;
    isConsorcioSearching: boolean = false;
    isConceptosRecargoSearching: boolean = false;
    isMetodosRedondeoExpensaSearching: boolean = false;
    isTiposGastosSearching: boolean = false;
    isComunidadTipoGastoServicioSearching: boolean = false;
    isComunidadTiposGastoConceptoRecargoSearching: boolean = false;
    isUfSearching: boolean = false;
    isTipoGastoComunidadSearching: boolean = false;
    isServicioSearching: boolean = false;
    isMonedaSearching: boolean = false;
    isTipoMovimientoSearching: boolean = false;
    isGastoSearching: boolean = false;
    isSimulating: boolean = false;

    verOtrosGastosPendientes: boolean = false;
    enviarExpensa: boolean = false;
    canGastoAdd: boolean = false;

    mesesList: any[];
    comunidadList: Comunidad[];
    conceptosRecargoList: ConceptosRecargo[];
    metodosRedondeoExpensaList: MetodoRedondeoExpensa[];
    tiposGastosList: TipoGasto[];
    tipoGastoComunidadList: TipoGasto[];
    ufPorcentajesList: UnidadFuncionalTipoGastoPorcentajeItemDto[];
    serviciosList: ServicioGasto[];
    comunidadTipoGastoServicioList: ExpensaTipoGastoComunidadServicioGasto[];
    comunidadTipoGastoList: ComunidadTiposGastos[];
    monedaList: Moneda[];
    tipoMovimientoList: TipoMovimiento[];

    gastosComunidadPendientesList: any[]; //SearchPendientesLiquidacionItem[];
    gastosUfPendientesList: any[]; //SearchPendientesLiquidacionItem[];

    tenantFeatureFlags: TenantFeatureFlags;

    cantidadGastosTotalSeleccionado: number = 0;
    gastosTotalSeleccionado: number = 0;
    cantidadGastosComunidadTotalSeleccionado: number = 0;
    gastosComunidadTotalSeleccionado: number = 0;
    cantidadGastosUfTotalSeleccionado: number = 0;
    gastosUfTotalSeleccionado: number = 0;

    tipoGastosString: string;
    tipoGastosConceptosRecargoString: string;

    expensaResultado: SaveExpensaLiquidacionResponseDto;
    ufTipoGastoPorcentajesFlexValue: number = 15;
    consorcioSeleccionado: Consorcio | null;
    comunidadSeleccionada: Comunidad | null;
    msgError: string = "";
    step: number = 0;

    constructor(
        private formBuilder: FormBuilder,
        private location: Location,
        private sharedFunctions: SharedFunctions,
        public dialog: MatDialog,
        private router: Router,
        private menuFuncionService: MenuFuncionService,
        private expensaService: ExpensaService,
        private gastoService: GastoService,
        private monedaService: MonedaService,
        private comunidadService: ComunidadService,
        private consorcioService: ConsorcioService,
        private tenantService: TenantService,
        private tipoMovimientoService: TipoMovimientoService,
        private servicioGastoService: ServicioGastoService,
        private tipoGastoService: TipoGastoService
    ) {
        this.gastosSelectionOptions = { persistSelection: true, type: 'Multiple', checkboxOnly: true };
    }

    ngOnInit(): void {
        this.isValidating = true;
        this.menuFuncionService.checkMenu(MenuFuncionCodes.EXPENSA_LIQUIDACION).subscribe(data => {
            if (data != null && data.Success && data?.Result) {

                this.tenantService.getTenantFeatureFlagsById(this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.TenantId)).subscribe(dataTenant => {
                    this.isValidating = false;
                    if (dataTenant != null && dataTenant.Success) {
                        this.tenantFeatureFlags = dataTenant.Result;
                        
                        this.isValidating = false;
                        this.canView = true;
                        this.loadView();
                    }
                    else {
                        this.isValidating = false;
                        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
                        this.router.navigate(['/']);
                    }
                },
                (err: HttpErrorResponse) => {
                    this.isValidating = false;
                    this.sharedFunctions.handleError(err, true);
                })
            }
        },
        (err: HttpErrorResponse) => {
            this.isValidating = false;
            this.sharedFunctions.handleError(err, true);
        });
    }

    loadView() {
        this.pageSizes = GridPageSettings.PageSizeList;
        this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };
        

        this.getMeses();

        this.buildForm0();
        this.buildForm1();
        this.buildForm2();
        this.buildForm3();

        this.menuFuncionService.checkMenu(MenuFuncionCodes.EXPENSA_CONFIG).subscribe(data => {
            if (data != null && data.Success && data?.Result) {
                this.canConfigExpensas = true;
            }
        },
        (err: HttpErrorResponse) => {
            this.sharedFunctions.handleError(err);
        });

        this.menuFuncionService.checkMenu(MenuFuncionCodes.GASTO_ADD).subscribe(data => {
            if (data != null && data.Success && data?.Result) {
                this.canGastoAdd = true;
            }
        },
        (err: HttpErrorResponse) => {
            this.sharedFunctions.handleError(err);
        });

        this.getComunidades();
    }

    buildForm0() {
        var hoy = new Date();

        //Por default seteo el mes anterior al actual
        var mesDefault = this.mesesList?.filter(f => f.Id == hoy.getMonth());
        if (hoy.getMonth() == 0)
            mesDefault = this.mesesList?.filter(f => f.Id == 12);

        this.form0Group = this.formBuilder.group({
            'Comunidad': [null, Validators.required],
            'PeriodoMes': [mesDefault[0], Validators.required],
            'PeriodoAnio': [hoy.getFullYear(), Validators.required],
            'FechaExpensa': [hoy, Validators.required]
        });
    }

    getError0Comunidad() {
        var v = this.form0Group.get('Comunidad');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getMeses() {
        this.mesesList = this.sharedFunctions.getMonthList();
    }

    compareMeses(o1: any, o2: any): boolean {
        return o1?.Id == o2?.Id;
    }

    getComunidades() {
        var cId = this.sharedFunctions.getLocalStorageValue(LocalStorageKeys.ConsorcioId);
        if (cId != null && cId.length > 0 && cId > 0)
            cId = Number(cId);

        var r = new SearchComunidadRequest(null, null, true, "Nombre", null, cId, null, null, null, true);
        this.isComunidadSearching = true; 
    
        this.comunidadService.search(r).subscribe(data => {
          this.isComunidadSearching = false;
          if (data != null)
            this.comunidadList = data?.result;
        },
        (err: HttpErrorResponse) => {
          this.isComunidadSearching = false; 
          this.sharedFunctions.handleError(err);
        });
    }

    getConceptosRecargo() {
        this.isConceptosRecargoSearching = true;
        this.consorcioService.getConceptosRecargo().subscribe(data => {
          this.isConceptosRecargoSearching = false;
          if (data != null)
            this.conceptosRecargoList = data?.Result;
        },
        (err: HttpErrorResponse) => {
          this.isConceptosRecargoSearching = false;
          this.sharedFunctions.handleError(err);
        });
    }
    
    getMetodosRedondeoExpensa() {
        this.isMetodosRedondeoExpensaSearching = true;
        this.consorcioService.getMetodosRedondeoExpensa().subscribe(data => {
          this.isMetodosRedondeoExpensaSearching = false;
          if (data != null)
            this.metodosRedondeoExpensaList = data?.Result;
        },
        (err: HttpErrorResponse) => {
          this.isMetodosRedondeoExpensaSearching = false;
          this.sharedFunctions.handleError(err);
        });
    }

    getTiposGastos() {
        var r = new SearchTipoGastoRequest(null, null, true, "Nombre", null, null, null, null, true);
        this.isTiposGastosSearching = true;
    
        this.tipoGastoService.search(r).subscribe(data => {
          this.isTiposGastosSearching = false;
          if (data != null)
            this.tiposGastosList = data?.result;
        },
          (err: HttpErrorResponse) => {
            this.isTiposGastosSearching = false;
            this.sharedFunctions.handleError(err);
          });
    }

    compareTipoGastos(o1: number, o2: number): boolean {
        return o1 == o2;
    }

    onInitialConfigChange() {
        this.setStep(0);
        this.comunidadSeleccionada = null;
    }

    onComunidadSelection(revisaConfiguracion: boolean) {
        var m = this.form0Group.get("PeriodoMes")?.value?.Id;
        if (m == null || m < 1 || m > 12) {
            this.sharedFunctions.showMessage("Debe seleccionar un mes válido", "Error");
            return false;
        }

        var y = this.form0Group.get("PeriodoAnio")?.value;
        if (y == null || y < 2000) {
            this.sharedFunctions.showMessage("Debe seleccionar un año válido", "Error");
            return false;
        }

        this.form0Group.get("FechaExpensa")?.setValue(new Date(y, m, 1));

        if (!this.form0Group.valid) {
            this.sharedFunctions.showMessage("Por favor seleccione una comunidad y un período a liquidar para continuar", "Error");
            return false;
        }

        this.comunidadSeleccionada = this.form0Group.get("Comunidad")?.value;
        this.step = 0;
        this.setStep(1);

        if (!revisaConfiguracion) 
            this.onStep1Guardar();
    }

    setStep(index: number) {
        if (index == 3 && this.step != 3) {
            if (this.hasStep2Completed()) 
                this.loadStep3();
            else
                index = 2;
        }

        if (index == 2 && this.step != 2) {
            if (this.hasStep1Completed()) 
                this.loadStep2();
            else
                index = 1;
        }

        if (index == 1 && this.step != 1) {
            if (this.comunidadSeleccionada != null && this.comunidadSeleccionada.Id > 0)
                this.loadStep1();
            else
                this.sharedFunctions.showMessage("Por favor seleccione una comunidad para continuar", "Error");
        }

        this.step = index;
    }

    onCancel() {
        this.location.back();
    }

//#region STEP 1

    loadStep1() {
        this.getConsorcio(this.comunidadSeleccionada?.ConsorcioId);
        this.getComunidadUnidadesFuncionalesPorcentajes();
        this.getComunidadTiposGastoConceptoRecargo(this.comunidadSeleccionada?.Id);
        
        if (this.form0Group.get("FechaExpensa")?.value != null) {

            if (this.form3Group?.get("FechaVencimiento")?.value == null || this.form3Group?.get("FechaVencimiento")?.value.length == 0)
                this.form3Group.get("FechaVencimiento")?.setValue(new Date(this.form0Group.get("FechaExpensa")?.value.getFullYear(), this.form0Group.get("FechaExpensa")?.value.getMonth(), 10));

            if (this.form3Group?.get("FechaVencimiento2")?.value == null || this.form3Group?.get("FechaVencimiento2")?.value.length == 0)
                this.form3Group.get("FechaVencimiento2")?.setValue(new Date(this.form0Group.get("FechaExpensa")?.value.getFullYear(), this.form0Group.get("FechaExpensa")?.value.getMonth(), 20));
        }
    }

    buildForm1() {
        this.form1Group = this.formBuilder.group({
            'TipoGastos': [null, Validators.required],
            'InteresVencimiento': [null, Validators.required],
            'InteresMensual': [null, Validators.required],
            'MetodoRedondeoExpensa': [null, Validators.required],
            'ConceptosRecargo': [null, Validators.required],
            'NotaExpensas': [null, Validators.maxLength(1000)],
            'NotaExpensasPie': [null, Validators.maxLength(1000)]
        });
    }

    getConsorcio(id) {
        this.isConsorcioSearching = true;
        this.consorcioService.get(id).subscribe(data => {
            this.isConsorcioSearching = false;
            if (data != null && data.Success) {
                this.consorcioSeleccionado = data.Result;
                this.mostrarSeleccionConceptosRecargo = (this.consorcioSeleccionado.ConceptosRecargo == ConceptosRecargoConstants.GastosSeleccionados);
            }
        },
        (err: HttpErrorResponse) => {
            this.isConsorcioSearching = false;
            this.sharedFunctions.handleError(err);
        })
    }

    getComunidadTiposGastoConceptoRecargo(id) {
        if (id == null || id <= 0)
            return false;

        this.isComunidadTiposGastoConceptoRecargoSearching = true;
        this.comunidadService.getTiposGastoConceptoRecargo(id).subscribe(data => {
            this.isComunidadTiposGastoConceptoRecargoSearching = false;
            if (data != null)
                this.tipoGastosConceptosRecargoString = data.Result?.map(item => item?.TipoGasto).join(', ');
        },
        (err: HttpErrorResponse) => {
          this.isComunidadTiposGastoConceptoRecargoSearching = false;
          this.sharedFunctions.handleError(err);
        })
    }

    getErrorTipoGastos() {
        var v = this.form1Group.get('TipoGastos');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getErrorInteresVencimiento() {
        var v = this.form1Group.get('InteresVencimiento');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getErrorInteresMensual() {
        var v = this.form1Group.get('InteresMensual');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getErrorMetodoRedondeoExpensa() {
        var v = this.form1Group.get('MetodoRedondeoExpensa');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getErrorConceptosRecargo() {
        var v = this.form1Group.get('ConceptosRecargo');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getNotaExpensas() {
        var v = this.form1Group.get('NotaExpensas');
        if (v?.hasError('maxlength'))
          return 'Límite de 1000 caracteres alcanzado';
        return '';
    }
    
    getNotaExpensasPie() {
        var v = this.form1Group.get('NotaExpensasPie');
        if (v?.hasError('maxlength'))
            return 'Límite de 1000 caracteres alcanzado';
        return '';
    }

    getComunidadUnidadesFuncionalesPorcentajes() {
        if (this.comunidadSeleccionada?.Id == null || this.comunidadSeleccionada?.Id < 0)
            return;

        var r = new ExpensaUnidadFuncionalGastosPorcentajeRequestDto(this.comunidadSeleccionada?.Id);
        this.isUfSearching = true; 

        this.expensaService.getUnidadFuncionalGastoPorcentajes(r).subscribe(data => {
          this.isUfSearching = false;
          this.ufPorcentajesList = data?.Result?.Porcentajes;
          this.hayUfsSinCubrirTotal = data.Result.HayUfsSinCubrirTotal;

          if (this.ufPorcentajesList != null)
            this.ufTipoGastoPorcentajesFlexValue = 65 / this.ufPorcentajesList.length;
        },
        (err: HttpErrorResponse) => {
          this.isUfSearching = false; 
          this.sharedFunctions.handleError(err, true);
        });
    }

    sumUfPorcentaje(gastoId: number) {
        return this.ufPorcentajesList.reduce(function (accumulator, item) {
            var val = item.TipoGastoPorcentajes.filter(x => x.TipoGastoId == gastoId).reduce(function (accum, g) { return accum + g.Porcentaje; }, 0);
            return accumulator + val;
          }, 0);
    }

    hasStep1Completed() {
        // var valid = (this.form1Group.get('TipoGastos')?.valid &&
        //     this.form1Group.get('InteresVencimiento')?.valid &&
        //     this.form1Group.get('InteresMensual')?.valid &&
        //     this.form1Group.get('MetodoRedondeoExpensa')?.valid &&
        //     this.form1Group.get('ConceptosRecargo')?.valid &&
        //     this.form1Group.get('NotaExpensas')?.valid &&
        //     this.form1Group.get('NotaExpensasPie')?.valid);

        // if (valid) {
        //     var iv = this.form1Group.get('InteresVencimiento')?.value;
        //     if (iv < 0 || iv > 100) {
        //         this.sharedFunctions.showMessage("El interés de vencimiento debe tener un valor entre 0 y 100", "Error");
        //         return false;
        //     }

        //     var im = this.form1Group.get('InteresMensual')?.value;
        //     if (im < 0 || im > 100) {
        //         this.sharedFunctions.showMessage("El interés mensual debe tener un valor entre 0 y 100", "Error");
        //         return false;
        //     }
        // }

        // return valid;
        return true;
    }

    onStep1Guardar() {
        this.setStep(2);

        // var r = new SaveExpensaConfiguration1RequestDto(null, null, null, null, null, null, null, null, null);
        // r = 
        // {
        //     ...this.form1Group.value,
        //     ComunidadId: this.comunidadSeleccionada.Id, 
        //     ConsorcioId: this.comunidadSeleccionada.ConsorcioId
        // };

        // this.isSaving = true;
        // this.expensaService.saveConfig1(r).subscribe(data => {
        //     this.isSaving = false;
        //     if (data.Success) {
        //         this.setStep(2);
        //     }
        //     else
        //         this.sharedFunctions.showMessage("Ocurrió un error llevando a cabo la operación. Intente nuevamente o contacte con el administrador del sistema", "Error");
        // },
        // (err: HttpErrorResponse) => {
        //     this.isSaving = false;
        //     this.sharedFunctions.handleError(err, true);
        // });
    }

    goExpensaConfig() {
        if (this.canConfigExpensas)
            this.router.navigate(['expensa-configuracion'], { state: { comunidad: this.comunidadSeleccionada }});
    }

//#endregion

//#region STEP 2

    loadStep2() {
        this.getTiposGastosByComunidad();
        this.getServicios();
        this.getMonedas();

        this.onGastoSearch();
    }

    buildForm2() {
        this.form2Group = this.formBuilder.group({
            'TipoGastoId': [null],
            'MonedaId': [null],
            'Servicios': [null],
            'FechaGastoDesde': [null],
            'FechaGastoHasta': [null]
        });
    }

    getTiposGastosByComunidad() {
        this.isTipoGastoComunidadSearching = true;
        this.comunidadService.getTiposGasto(this.comunidadSeleccionada?.Id ?? 0).subscribe(data => {
            this.isTipoGastoComunidadSearching = false;
            this.comunidadTipoGastoList = data?.Result;
        },
        (err: HttpErrorResponse) => {
            this.isTipoGastoComunidadSearching = false;
            this.sharedFunctions.handleError(err);
        });
    }

    getMonedas() {
        var r = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
        this.isMonedaSearching = true;

        this.monedaService.search(r).subscribe(data => {
            this.isMonedaSearching = false;
            this.monedaList = data?.result;
        },
        (err: HttpErrorResponse) => {
            this.isMonedaSearching = false;
            this.sharedFunctions.handleError(err);
        });
    }

    getServicios() {
        var r = new SearchServicioGastoRequest(null, null, true, "Nombre", null, null, null, null, true);
        this.isServicioSearching = true;
    
        this.servicioGastoService.search(r).subscribe(data => {
          this.isServicioSearching = false;
          if (data != null)
            this.serviciosList = data?.result;
        },
        (err: HttpErrorResponse) => {
        this.isServicioSearching = false;
        this.sharedFunctions.handleError(err);
        });
    }

    compareServicios(o1: number, o2: number): boolean {
        return o1 == o2;
    }

    onGastoAdd() {
        if (this.canGastoAdd) {
            const url = this.router.serializeUrl(this.router.createUrlTree(['#/gasto-edit', 0]));
            window.open(url.replace('%23','#'), '_blank');
            // this.router.navigate(['gasto-edit', 0]);
        }
        else
            this.sharedFunctions.showMessage("No tiene permisos para llevar a cabo la operación", "Error");
    }

    clearDate(formFieldName: string) {
        if (formFieldName != null && formFieldName.length > 0) {
            if (this.form2Group.get(formFieldName) != null && this.form2Group.get(formFieldName)?.value)
                this.form2Group.get(formFieldName)?.setValue(null);
        }
    }

    onGastoSearch(shouldSearch: boolean = false) {
        if (!shouldSearch && 
            (this.gastosComunidadPendientesList != null && this.gastosComunidadPendientesList.length > 0 && this.gastosComunidadPendientesList.some(f => f.Seleccionado == true)) &&
            (this.gastosUfPendientesList != null && this.gastosUfPendientesList.length > 0 && this.gastosUfPendientesList.some(f => f.Seleccionado == true)))
            return false;

        var serviciosString = (this.form2Group.get("Servicios")?.value as number[])?.join(",");
        var fechaBusquedaGasto = new Date(this.form0Group.get("FechaExpensa")?.value.getFullYear(), this.form0Group.get("FechaExpensa")?.value.getMonth() - 1, 1);

        var r = new SearchPendientesLiquidacionRequest(null, null, true, "FechaGasto", fechaBusquedaGasto, 
            this.comunidadSeleccionada?.ConsorcioId ?? 0, this.comunidadSeleccionada?.Id ?? 0, this.form2Group.get("TipoGastoId")?.value, 
            this.form2Group.get("MonedaId")?.value, serviciosString, [], this.verOtrosGastosPendientes,
            this.form2Group.get("FechaGastoDesde")?.value, this.form2Group.get("FechaGastoHasta")?.value);

        this.isGastoSearching = true;
        this.gastoService.searchPendientesLiquidacion(r).subscribe(data => {
            this.isGastoSearching = false;
            
            var seleccionados = this.gastosComunidadPendientesList?.filter(f => f.Seleccionado == true);
            if (seleccionados != null && seleccionados.length > 0) {
                for (var i=0; i<seleccionados.length; i++)
                    this.gastosComunidadPendientesList.find(f => f.Id == seleccionados[i].Id).Seleccionado = false;
            }

            var seleccionados2 = this.gastosUfPendientesList?.filter(f => f.Seleccionado == true);
            if (seleccionados2 != null && seleccionados2.length > 0) {
                for (var i=0; i<seleccionados2.length; i++)
                    this.gastosUfPendientesList.find(f => f.Id == seleccionados2[i].Id).Seleccionado = false;
            }
            
            this.gastosComunidadPendientesList = data?.result?.filter(f => f.UnidadFuncionalId == null);
            this.gastosUfPendientesList = data?.result?.filter(f => f.UnidadFuncionalId > 0);

            this.updateGastoTotal();
        },
        (err: HttpErrorResponse) => {
            this.isGastoSearching = false;
            this.sharedFunctions.handleError(err, true);
        });
    }

    onGridActionFailure(event: any): void {
        this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
    }

    onGastoComunidadDataBound(args: any) {
        var seleccionados = this.gastosComunidadPendientesList?.filter(f => f.Seleccionado == true);
    
        // Restaurar la selección de filas
        if (seleccionados != null && seleccionados.length > 0) {
          var pageRows = this.gastosComunidadGrid.getRowsObject();
          if (pageRows != null && pageRows.length > 0) {
            var indexes: number[] = [];
            for (var i=0; i<pageRows.length; i++) {
              if (seleccionados.some(f => f.Id == (pageRows[i].data as any).Id))
                indexes.push(pageRows[i].index);
            }
    
            if (indexes != null && indexes.length > 0)
              this.gastosComunidadGrid.selectRows(indexes);
          }
        }
    }

    onGastoComunidadRowSelected(args: RowSelectEventArgs) {
        if (args.isHeaderCheckboxClicked) {
            // var multiSelection = this.gastosComunidadGrid.getRowsObject();
            // if (multiSelection != null && multiSelection.length > 0) {
            //   for (var i=0; i<multiSelection.length; i++)
            //     this.gastosComunidadPendientesList.find(f => f.Id == (multiSelection[i].data as any).Id).Seleccionado = true;
            // }
            for (var i=0; i<this.gastosComunidadPendientesList.length; i++)
                this.gastosComunidadPendientesList[i].Seleccionado = true;
        }
        else {
            if (args?.data != null && (args?.data as any).Id != null)
                this.gastosComunidadPendientesList.find(f => f.Id == (args?.data as any).Id).Seleccionado = true;
        }

        this.updateGastoTotal();
    }

    onGastoComunidadRowDeselected(args: RowDeselectEventArgs) {
        //Solo cuando hace click en el checkbox de la grilla deselecciona
        if (args.isHeaderCheckboxClicked) {
            // var multiSelection = this.gastosComunidadGrid.getRowsObject();
            // if (multiSelection != null && multiSelection.length > 0) {
            // for (var i=0; i<multiSelection.length; i++)
            //     this.gastosComunidadPendientesList.find(f => f.Id == (multiSelection[i].data as any).Id).Seleccionado = false;
            // }
            for (var i=0; i<this.gastosComunidadPendientesList.length; i++)
                this.gastosComunidadPendientesList[i].Seleccionado = false;
        }
        else {
            if (args?.data != null  && (args?.data as any).Id != null && args?.target?.className == "e-frame e-icons e-uncheck")
                this.gastosComunidadPendientesList.find(f => f.Id == (args?.data as any).Id).Seleccionado = false;
        }
        
        this.updateGastoTotal();
    }

    onGastoUfDataBound(args: any) {
        var seleccionados = this.gastosUfPendientesList?.filter(f => f.Seleccionado == true);
    
        // Restaurar la selección de filas
        if (seleccionados != null && seleccionados.length > 0) {
          var pageRows = this.gastosUfsGrid.getRowsObject();
          if (pageRows != null && pageRows.length > 0) {
            var indexes: number[] = [];
            for (var i=0; i<pageRows.length; i++) {
              if (seleccionados.some(f => f.Id == (pageRows[i].data as any).Id))
                indexes.push(pageRows[i].index);
            }
    
            if (indexes != null && indexes.length > 0)
              this.gastosUfsGrid.selectRows(indexes);
          }
        }
    }

    onGastoUfRowSelected(args: RowSelectEventArgs) {
        if (args.isHeaderCheckboxClicked) {
            // var multiSelection = this.gastosUfsGrid.getRowsObject();
            // if (multiSelection != null && multiSelection.length > 0) {
            //   for (var i=0; i<multiSelection.length; i++)
            //     this.gastosUfPendientesList.find(f => f.Id == (multiSelection[i].data as any).Id).Seleccionado = true;
            // }
            for (var i=0; i<this.gastosUfPendientesList.length; i++)
                this.gastosUfPendientesList[i].Seleccionado = true;
        }
        else {
            if (args?.data != null && (args?.data as any).Id != null)
                this.gastosUfPendientesList.find(f => f.Id == (args?.data as any).Id).Seleccionado = true;
        }

        this.updateGastoTotal();
    }

    onGastoUfRowDeselected(args: RowDeselectEventArgs) {
        //Solo cuando hace click en el checkbox de la grilla deselecciona
        if (args.isHeaderCheckboxClicked) {
            // var multiSelection = this.gastosUfsGrid.getRowsObject();
            // if (multiSelection != null && multiSelection.length > 0) {
            // for (var i=0; i<multiSelection.length; i++)
            //     this.gastosUfPendientesList.find(f => f.Id == (multiSelection[i].data as any).Id).Seleccionado = false;
            // }
            for (var i=0; i<this.gastosUfPendientesList.length; i++)
                this.gastosUfPendientesList[i].Seleccionado = false;
        }
        else {
            if (args?.data != null  && (args?.data as any).Id != null && args?.target?.className == "e-frame e-icons e-uncheck")
                this.gastosUfPendientesList.find(f => f.Id == (args?.data as any).Id).Seleccionado = false;
        }
        
        this.updateGastoTotal();
    }

    updateGastoTotal() {
        this.gastosTotalSeleccionado = 0;
        this.cantidadGastosTotalSeleccionado = 0;
        this.gastosComunidadTotalSeleccionado = 0;
        this.cantidadGastosComunidadTotalSeleccionado = 0;
        this.gastosUfTotalSeleccionado = 0;
        this.cantidadGastosUfTotalSeleccionado = 0;

        var itemList = this.gastosComunidadPendientesList?.filter(f => f.Seleccionado == true);
        if (itemList != null && itemList.length > 0) {
            this.gastosComunidadTotalSeleccionado = (itemList?.reduce(function (accumulator, item) {
                return accumulator + (item?.Importe ?? 0);
            }, 0) ?? 0);
        }

        var itemList2 = this.gastosUfPendientesList?.filter(f => f.Seleccionado == true);
        if (itemList2 != null && itemList2.length > 0) {
            this.gastosUfTotalSeleccionado = (itemList2?.reduce(function (accumulator, item) {
                return accumulator + (item?.Importe ?? 0);
            }, 0) ?? 0);
        }

        this.gastosTotalSeleccionado = this.gastosComunidadTotalSeleccionado + this.gastosUfTotalSeleccionado;

        this.cantidadGastosComunidadTotalSeleccionado = (itemList?.length ?? 0);
        this.cantidadGastosUfTotalSeleccionado = (itemList2?.length ?? 0);
        this.cantidadGastosTotalSeleccionado = (itemList?.length ?? 0) + (itemList2?.length ?? 0);
    }

    hasStep2Completed() {
        var valid = (this.gastosComunidadPendientesList != null && this.gastosComunidadPendientesList.length > 0 && this.gastosComunidadPendientesList.some(f => f.Seleccionado == true)) ||
                    (this.gastosUfPendientesList != null && this.gastosUfPendientesList.length > 0 && this.gastosUfPendientesList.some(f => f.Seleccionado == true));
        if (!valid) {
            this.sharedFunctions.showMessage("Debe seleccionar al menos un gasto a liquidar en la expensa del mes", "Error");
            return false;
        }

        var monedaIdList = this.gastosComunidadPendientesList?.filter(f => f.Seleccionado == true).map(m => m.MonedaId);
        if (new Set(monedaIdList).size > 1) {
            this.sharedFunctions.showMessage("Todos los gastos deben tener la misma moneda", "Error");
            return false;
        }

        var monedaIdList2 = this.gastosUfPendientesList?.filter(f => f.Seleccionado == true).map(m => m.MonedaId);
        if (new Set(monedaIdList2).size > 1) {
            this.sharedFunctions.showMessage("Todos los gastos deben tener la misma moneda", "Error");
            return false;
        }

        return valid;
    }

    onStep2Guardar() {
        if (!this.hasStep2Completed())
            return false;

        this.setStep(3);
    }

//#endregion

//#region STEP 3

    loadStep3() { 
        this.getServicios();
        this.getTiposGastosByComunidad();
        this.getTiposMovimientos();
    }

    buildForm3() {
        this.form3Group = this.formBuilder.group({
            'FechaVencimiento': [null, Validators.required],
            'FechaVencimiento2': [null, Validators.required],
            'ImporteFondoOperativo': [0, Validators.required],
            'Observaciones': [null, Validators.maxLength(300)],
            'TipoMovimientoId': [null],
            'EnviarExpensa': [false],
            'PublicarExpensa': [false]
        });

        if (this.tenantFeatureFlags?.HabilitarControlCaja) {
            const tipoMovimientoControl = this.form3Group.get('TipoMovimientoId');
            if (tipoMovimientoControl != null) {
                tipoMovimientoControl.setValidators([Validators.required]);
                tipoMovimientoControl.updateValueAndValidity();
            }
        }
    }

    getTiposMovimientos() {
        if (!this.tenantFeatureFlags?.HabilitarControlCaja)
            return;
        
        var r = new SearchTipoMovimientoRequest(null, null, true, "Nombre", null, null, -1, null, true);
        this.isTipoMovimientoSearching = true;
    
        this.tipoMovimientoService.search(r).subscribe(data => {
          this.isTipoMovimientoSearching = false;
          this.tipoMovimientoList = data?.result;
        },
        (err: HttpErrorResponse) => {
          this.isTipoMovimientoSearching = false;
          this.sharedFunctions.handleError(err);
        });
    }

    getError3FechaVencimiento() {
        var v = this.form3Group.get('FechaVencimiento');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getError3FechaVencimiento2() {
        var v = this.form3Group.get('FechaVencimiento2');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }
    
    getError3ImporteFondoOperativo() {
        var v = this.form3Group.get('ImporteFondoOperativo');
        if (v?.hasError('required'))
          return 'El campo es obligatorio';
        return '';
    }

    getError3Observaciones() {
        var v = this.form3Group.get('Observaciones');
        if (v?.hasError('maxlength'))
          return 'Límite de 300 caracteres alcanzado';
        return '';
    }

    getErrorTipoMovimientoId() {
        return this.form3Group.get('TipoMovimientoId')?.hasError('required') ? 'El campo es obligatorio' : '';
    }

    onWheel(event: WheelEvent) {
        (event.target as HTMLElement).blur();
        event.preventDefault();
      }

    hasStep3Completed() {
        var valid = (this.form3Group.get('ImporteFondoOperativo')?.valid &&
            this.form3Group.get('FechaVencimiento')?.valid &&
            this.form3Group.get('FechaVencimiento2')?.valid &&
            this.form3Group.get('Observaciones')?.valid);

            
            if (this.tenantFeatureFlags?.HabilitarControlCaja)
                valid = valid && this.form3Group.get('TipoMovimientoId')?.valid;
            
        return valid;
    }

    onStep3Guardar() {
        if (!this.hasStep3Completed()) {
            this.sharedFunctions.showMessage("Complete todos los campos obligatorios para continuar con la operación", "Error");
            return false;
        }

        var gastosPendientes = [...new Set([...this.gastosComunidadPendientesList?.filter(f => f.Seleccionado == true), ...this.gastosUfPendientesList?.filter(f => f.Seleccionado == true)])];
        var debePublicarExpensa = this.form3Group.get("PublicarExpensa")?.value;

        var r = new SaveExpensaLiquidacionRequestDto(this.comunidadSeleccionada?.Id ?? 0, this.comunidadSeleccionada?.ConsorcioId ?? 0,
            this.form3Group.get("ImporteFondoOperativo")?.value, this.form3Group.get("Observaciones")?.value, this.form0Group.get("FechaExpensa")?.value, 
            this.form3Group.get("FechaVencimiento")?.value, this.form3Group.get("FechaVencimiento2")?.value, this.form3Group.get("EnviarExpensa")?.value, 
            debePublicarExpensa, this.form3Group.get("TipoMovimientoId")?.value, gastosPendientes);

        this.isSaving = true;
        this.expensaService.saveLiquidacion(r).subscribe(data => {
            this.isSaving = false;
            if (data.Success) {
                var msg = "Se liquidaron las expensas correctamente para " + this.comunidadSeleccionada?.Nombre + 
                    " y período " + this.form0Group.get("PeriodoMes")?.value?.Nombre + " " + this.form0Group.get("PeriodoAnio")?.value + "!";

                if (data.Result.EnvioExpensaResultado != null && data.Result.EnvioExpensaResultado.length > 0)
                    msg += " Pero ocurrió el siguiente problema al intentar realizar el envio por mail de la expensa: " + data.Result.EnvioExpensaResultado;

                if (!debePublicarExpensa)
                    msg += " Tené en cuenta que las mismas quedaron como borrador y no serán visibles para los usuarios. " +
                            "Cuando esté listo, deberá ingresar en la expensa y publicarla para que sea visible para todos.";

                this.sharedFunctions.showMessage(msg, "Operación Exitosa!");
                this.sharedFunctions.reloadCurrentRoute();
            }
            else
                this.sharedFunctions.showMessage("Ocurrió un error llevando a cabo la operación. Intente nuevamente o contacte con el administrador del sistema", "Error");
        },
        (err: HttpErrorResponse) => {
            this.isSaving = false;
            this.sharedFunctions.handleError(err, true);
        });
    }

    onSimulacionClick() {

        if (!this.hasStep3Completed()) {
            this.sharedFunctions.showMessage("Complete todos los campos obligatorios para continuar con la operación", "Error");
            return false;
        }

        var gastosPendientes = [...new Set([...this.gastosComunidadPendientesList?.filter(f => f.Seleccionado == true), ...this.gastosUfPendientesList?.filter(f => f.Seleccionado == true)])];

        var r = new SaveExpensaLiquidacionRequestDto(this.comunidadSeleccionada?.Id ?? 0, this.comunidadSeleccionada?.ConsorcioId ?? 0, 
            this.form3Group.get("ImporteFondoOperativo")?.value, this.form3Group.get("Observaciones")?.value, this.form0Group.get("FechaExpensa")?.value, 
            this.form3Group.get("FechaVencimiento")?.value, this.form3Group.get("FechaVencimiento2")?.value, this.form3Group.get("EnviarExpensa")?.value, 
            this.form3Group.get("PublicarExpensa")?.value, this.form3Group.get("TipoMovimientoId")?.value, gastosPendientes);

        this.isSimulating = true;
        this.expensaService.simulateLiquidacion(r).subscribe(data => {
            this.isSimulating = false;
            if (data.Success) {

                // data.Result.UfsLiquidacion.map(uf => )
                this.expensaResultado = data.Result;

                const dialogRef = this.dialog.open(DialogExpensaLiquidacionSimulacionComponent, {
                    width: '95%',
                    data: this.expensaResultado
                });
        
                dialogRef.afterClosed().subscribe((result: any) => {
                });
            }
        },
        (err: HttpErrorResponse) => {
            this.isSimulating = false;
            this.sharedFunctions.handleError(err, true);
        });
    }

    onExpensaResultadoClick() {
        if (this.expensaResultado == null) {
            this.sharedFunctions.showMessage("Debe liquidar expensas para continuar con la operación", "Error");
            return false;
        }

        this.router.navigate(['expensa-edit', this.expensaResultado.ExpensaCabeceraId]);
    }

//#endregion
}